import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-colum h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex justify-content-between bd-highlight mb-3",
  style: {"margin-top":"20px"}
}, null, -1)
const _hoisted_3 = { class: "d-flex flex-row flex-wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RichEditorDialog = _resolveComponent("RichEditorDialog")!
  const _component_AppOtherDialog = _resolveComponent("AppOtherDialog")!
  const _component_AppVersionDialog = _resolveComponent("AppVersionDialog")!
  const _component_AppCheckRoomDialog = _resolveComponent("AppCheckRoomDialog")!
  const _component_AboutDialog = _resolveComponent("AboutDialog")!
  const _component_AppVipsDialog = _resolveComponent("AppVipsDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openEditorDialog('brand', '品牌故事'))),
          class: "item-block"
        }, [
          _createTextVNode("品 牌"),
          _hoisted_4,
          _createTextVNode("故 事")
        ]),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openEditorDialog('manghe', '潮玩盲盒'))),
          class: "item-block"
        }, [
          _createTextVNode("潮 玩"),
          _hoisted_5,
          _createTextVNode("盲 盒")
        ]),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openEditorDialog('food', '月子餐'))),
          class: "item-block"
        }, [
          _createTextVNode("月 子"),
          _hoisted_6,
          _createTextVNode("餐 食")
        ]),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.openEditorDialog('huli', '专业护理'))),
          class: "item-block"
        }, [
          _createTextVNode("专 业"),
          _hoisted_7,
          _createTextVNode("护 理")
        ]),
        (_ctx.job==='店长')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.openEditorDialog('privacy', '隐私政策'))),
              class: "item-block"
            }, [
              _createTextVNode("隐 私"),
              _hoisted_8,
              _createTextVNode("政 策")
            ]))
          : _createCommentVNode("", true),
        (_ctx.job==='店长')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openEditorDialog('agreement', '用户协议'))),
              class: "item-block"
            }, [
              _createTextVNode("用 户"),
              _hoisted_9,
              _createTextVNode("协 议")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openRuleDialog('invite','邀请'))),
          class: "item-block"
        }, [
          _createTextVNode("邀 请"),
          _hoisted_10,
          _createTextVNode("配 置")
        ]),
        _createElementVNode("div", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openRuleDialog('yuyue','预约'))),
          class: "item-block"
        }, [
          _createTextVNode("预 约"),
          _hoisted_11,
          _createTextVNode("配 置")
        ]),
        _createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openRuleDialog('checkroom','查房配置'))),
          class: "item-block"
        }, [
          _createTextVNode("查 房"),
          _hoisted_12,
          _createTextVNode("配 置")
        ]),
        (_ctx.job==='店长')
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.openRuleDialog('vips','会员配置'))),
              class: "item-block"
            }, [
              _createTextVNode("会 员"),
              _hoisted_13,
              _createTextVNode("配 置")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.openRuleDialog('android','安卓版本'))),
          class: "item-block"
        }, [
          _createTextVNode("安 卓"),
          _hoisted_14,
          _createTextVNode("版 本")
        ]),
        (_ctx.isBlue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.openRuleDialog('about','关于我们'))),
              class: "item-block"
            }, [
              _createTextVNode("关 于"),
              _hoisted_15,
              _createTextVNode("我 们")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_RichEditorDialog, {
      ref: "editorDialogRef",
      title: _ctx.editTitle,
      show: _ctx.showEditorDialog,
      onConfirm: $setup.submitEditorContent,
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEditorDialog=false))
    }, null, 8, ["title", "show", "onConfirm"]),
    _createVNode(_component_AppOtherDialog, {
      title: _ctx.editTitle,
      item: _ctx.editing,
      show: _ctx.showRuleDialog,
      onConfirm: $setup.submitRule,
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showRuleDialog=false))
    }, null, 8, ["title", "item", "show", "onConfirm"]),
    _createVNode(_component_AppVersionDialog, {
      title: _ctx.editTitle,
      item: _ctx.editing,
      show: _ctx.showVersionDialog,
      onConfirm: $setup.submitRule,
      onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showVersionDialog=false))
    }, null, 8, ["title", "item", "show", "onConfirm"]),
    _createVNode(_component_AppCheckRoomDialog, {
      title: _ctx.editTitle,
      item: _ctx.editing,
      show: _ctx.showCheckRoomDialog,
      onConfirm: $setup.submitRule,
      onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showCheckRoomDialog=false))
    }, null, 8, ["title", "item", "show", "onConfirm"]),
    _createVNode(_component_AboutDialog, {
      title: _ctx.editTitle,
      item: _ctx.editing,
      show: _ctx.showAboutDialog,
      onConfirm: $setup.submitRule,
      onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showAboutDialog=false))
    }, null, 8, ["title", "item", "show", "onConfirm"]),
    _createVNode(_component_AppVipsDialog, {
      title: _ctx.editTitle,
      item: _ctx.editing,
      show: _ctx.showVipsDialog,
      onConfirm: $setup.submitRule,
      onCancel: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showVipsDialog=false))
    }, null, 8, ["title", "item", "show", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}